import React from 'react'

const EditPropertyEmployee = () => {
  return (
    <div>EditPropertyEmployee</div>
  )
}

export default EditPropertyEmployee